export class NavigationItem {
  name: string;
  canonical?: string;
  route?: string;
  isDropDown: boolean;
  external?: boolean;
  topLevel?: boolean;
  metaImageAlt?: string;
  metaImage?: string;
  metaTitle?: string;
  metaDescription?: string;
  $key?: string;

  children?: NavigationItem[];

  constructor() {
    this.external = false;
    this.topLevel = false;
    this.isDropDown = false;
    this.children = [];
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/navigationItem.ts